export enum CacheType {
    ToolDocumentLocations = 1,
    TaskDocumentLocations = 2
}
